__turbopack_context__.v({
  "bare": "FeatureGrid-module__VpkBAa__bare",
  "body": "FeatureGrid-module__VpkBAa__body",
  "businessChoice": "FeatureGrid-module__VpkBAa__businessChoice",
  "card": "FeatureGrid-module__VpkBAa__card",
  "circleImage": "FeatureGrid-module__VpkBAa__circleImage",
  "ctaButtons": "FeatureGrid-module__VpkBAa__ctaButtons",
  "featureIcon": "FeatureGrid-module__VpkBAa__featureIcon",
  "featureIconSvg": "FeatureGrid-module__VpkBAa__featureIconSvg",
  "grid": "FeatureGrid-module__VpkBAa__grid",
  "heading": "FeatureGrid-module__VpkBAa__heading",
  "icon": "FeatureGrid-module__VpkBAa__icon",
  "iconWrapper": "FeatureGrid-module__VpkBAa__iconWrapper",
  "image": "FeatureGrid-module__VpkBAa__image",
  "imageComparison": "FeatureGrid-module__VpkBAa__imageComparison",
  "imageWrapper": "FeatureGrid-module__VpkBAa__imageWrapper",
  "intro": "FeatureGrid-module__VpkBAa__intro",
  "item": "FeatureGrid-module__VpkBAa__item",
  "itemCta": "FeatureGrid-module__VpkBAa__itemCta",
  "itemCtaButton": "FeatureGrid-module__VpkBAa__itemCtaButton",
  "itemCtaOutlineButton": "FeatureGrid-module__VpkBAa__itemCtaOutlineButton",
  "media": "FeatureGrid-module__VpkBAa__media",
  "nvrFeatureColumn": "FeatureGrid-module__VpkBAa__nvrFeatureColumn",
  "nvrFeatures": "FeatureGrid-module__VpkBAa__nvrFeatures",
  "productCards": "FeatureGrid-module__VpkBAa__productCards",
  "secondaryHeading": "FeatureGrid-module__VpkBAa__secondaryHeading",
  "valuePillars": "FeatureGrid-module__VpkBAa__valuePillars",
  "wellCards": "FeatureGrid-module__VpkBAa__wellCards",
  "wrapper": "FeatureGrid-module__VpkBAa__wrapper",
});
